// @import dependencies
import { CombinedReducers as IState } from 'app_events/index'
import { store } from 'app_storage/redux-storage'
import React, { Component } from 'react'
import { connect } from 'react-redux'
// @end

// @import components
import { ActivitySummaryModuleLayout } from 'app_components/modules/campus/academic/activitySummary'
// @end

// @import events
// @end

// @import utils
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import CourseActivityService from 'app_services/campus/academic/courseActivityService'
import storeService from 'app_services/storeService'
// @end

// @import types
import { IActivitySummary } from 'app_types/campus/academic/activitySummaryTypes'
import { IMyCourse } from 'app_types/campus/academic/myCoursesTypes'
// @end

// @ADD Component types
interface IActivitySummaryModuleProps { }
interface IActivitySummaryModuleState {
  defaultStatus: boolean
  activityData: any
  chartOptions: any
  status: 'loading' | 'error' | null
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => { return state }

class ActivitySummaryModule extends Component<IActivitySummaryModuleProps, IActivitySummaryModuleState> {

  private storeObject = store
  private courseActivityService: CourseActivityService
  // private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IActivitySummaryModuleProps) {
    super(props)
    this.state = {
      defaultStatus: false,
      activityData: null,
      chartOptions: {},
      status: 'loading',
    }

    // this.i18nUtil = new I18nUtil()
    this.courseActivityService = new CourseActivityService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    storeService?.subscribe('courses.courseSelected', this.fetchActivitySummary)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    storeService?.unsubscribe('courses.courseSelected', this.fetchActivitySummary)
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => { }

  // @Add custom methods
  fetchActivitySummary = async (data: IMyCourse | null) => {
    if (data) {
      this.setState({ status: 'loading', activityData: null })

      let auth = this.storeObject.getState().auth

      const dataResponse = await this.courseActivityService.fetchActivitySummaryStats({
        courseID: data?._id,
        course_scheduling: data?.courseScheduling,
        userMoodleID: auth?.user?.data?.moodle?.moodle_id,
        username: auth?.user?.data?.username,
      }, {
        showError: false,
      })

      if (dataResponse) {
        if (dataResponse?.summary) {
          const activity: IActivitySummary = {}

          //if (dataResponse?.summary.schedulingMode === 'virtual') {
            if (dataResponse?.summary?.totalAdvance !== undefined) {
              const progress = dataResponse?.summary?.totalAdvance || 0
              let progressExtra: any = {
                pathColor: undefined,
                textColor: '#7C878E',
              }
              if (progress > 0) {
                if (progress < 70) {
                  progressExtra.pathColor = 'red'
                  progressExtra.textColor = 'red'
                } else {
                  progressExtra.pathColor = '#3e98c7'
                  progressExtra.textColor = '#3e98c7'
                }
              }

              activity.progress = {
                value: progress,
                pathColor: progressExtra.pathColor,
                textColor: progressExtra.textColor,
              }
              activity.totalAdvance = dataResponse?.summary?.totalAdvance ? `${dataResponse?.summary?.totalAdvance}%` : '-'
            }

          //}

          if (dataResponse?.summary?.emissionCertificate) {
            activity.emissionCertificate = dataResponse.summary.emissionCertificate
          }

          if (dataResponse?.summary?.finalNote) {
            activity.finalNote = dataResponse?.summary?.finalNote
          }

          if (dataResponse?.summary?.certification) {
            activity.certification = dataResponse?.summary?.certification
          }
          if (dataResponse?.summary?.auditorCertification) {
            activity.auditorCertification = dataResponse?.summary?.auditorCertification
          }
          if (dataResponse?.summary?.attendance !== undefined) {
            activity.attendance = dataResponse.summary.attendance
          }
          if (dataResponse?.summary?.attendanceInformation !== undefined) {
            activity.attendanceInformation = dataResponse.summary.attendanceInformation
          }
          if (dataResponse?.summary?.activities) {
            activity.activities = dataResponse.summary.activities
          }

          // console.log('It has auditor data? : ' + dataResponse?.summary?.auditor)

          // activity.note = dataResponse?.summary?.finalGrade ? dataResponse?.summary?.finalGrade : ''
          // activity.certificateIssueState = dataResponse?.summary?.certificateIssueState ? dataResponse?.summary?.certificateIssueState : ''
          // activity.programFinalState = dataResponse?.summary?.programFinalState ? dataResponse?.summary?.programFinalState : ''
          // activity.includeAuditorData = dataResponse?.summary?.auditor
          // activity.auditorExam = dataResponse?.summary?.auditorGradeC2 ? dataResponse?.summary?.auditorGradeC2 : 0

          this.setState({ status: null, activityData: activity })
        }

        // if (dataResponse?.completion && dataResponse?.completion[0] && dataResponse?.completion[0][0]) {
        //   const activity: IActivitySummary = {}
        //   if (dataResponse?.schedulingMode === 'virtual') {
        //     const progress = dataResponse?.completion[0][0].student?.studentProgress?.completion || 0
        //     let progressExtra: any = {
        //       pathColor: undefined,
        //       textColor: '#7C878E',
        //     }
        //     if (progress > 0) {
        //       if (progress < 70) {
        //         progressExtra.pathColor = 'red'
        //         progressExtra.textColor = 'red'
        //       } else {
        //         progressExtra.pathColor = '#3e98c7'
        //         progressExtra.textColor = '#3e98c7'
        //       }
        //     }
        //     activity.progress = {
        //       value: progress,
        //       pathColor: progressExtra.pathColor,
        //       textColor: progressExtra.textColor,
        //     }
        //     activity.note = dataResponse?.completion[0][0].student?.studentProgress?.average_grade ? `${dataResponse?.completion[0][0].student?.studentProgress?.average_grade}%` : '-'
        //   } else {
        //     activity.attendance = dataResponse?.completion[0][0].student?.studentProgress?.assistance || '-'
        //     activity.exam = dataResponse?.completion[0][0].student?.studentProgress?.quizGrade || '-'
        //   }
        //   activity.certificate = dataResponse?.completion[0][0].student?.studentProgress?.attended_approved || '-'
        //   if (dataResponse?.isAuditorCerficateEnabled) {
        //     activity.auditorCertificate = dataResponse?.completion[0][0].student?.studentProgress?.auditorCertificate || '-'
        //     activity.auditorExam = dataResponse?.completion[0][0].student?.studentProgress?.auditorGrade ? `${dataResponse?.completion[0][0].student?.studentProgress?.auditorGrade}%` : '-'
        //   }
        //   this.setState({status: null, activityData: activity})
        // }
        else {
          this.setState({ status: 'error', activityData: null })
        }
      } else {
        this.setState({ status: 'error', activityData: null })
      }
    } else {
      this.setState({ status: null, activityData: null })
    }
  }

  render() {
    return (
      <ActivitySummaryModuleLayout
        defaultStatus={this.state.defaultStatus}
        activityData={this.state.activityData}
        chartOptions={this.state.chartOptions}
        status={this.state.status}
      />
    )
  }
}

export default connect(mapStatesToProps)(ActivitySummaryModule)
